var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LogoWithMono from '../../../LogoWithMono';
const LogoTrenitaliaEn = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 60, height: 18, viewBox: "0 0 60 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M33.6006 0L31.9642 4.49954H17.1023C16.9537 4.98304 16.6015 5.98249 16.0458 7.4979L30.8738 7.49924L29.7669 10.5409L14.9165 10.5403C14.6492 11.2543 14.3582 12.0282 14.0436 12.862L13.8032 13.4986H28.6915L27.6012 16.4983C27.3653 17.0543 27.1564 17.5549 26.9745 18L13.8032 17.9982C11.5482 17.9982 9.79374 17.5796 9.30364 16.4983C8.70334 15.1739 9.15259 14.0041 9.30364 13.4986C9.45469 12.9932 11.7753 6.82272 12.8409 4.26821C13.4824 2.71821 13.903 1.79543 14.1026 1.49985C14.6245 0.544798 15.6685 0.0701759 16.8319 0.00724552L17.1023 0H33.6006ZM40.735 0L42.7286 11.9118L47.0988 0H51.8849L45.2873 17.9982L40.4968 17.9967L38.355 6.48834L34.1374 17.9982H29.3469L35.949 0H40.735Z", fill: "black" }))),
        alt: 'Trenitalia En',
    };
    return React.createElement(LogoWithMono, Object.assign({}, commonProps, { fixedHeight: 18, source: source }));
};
export default LogoTrenitaliaEn;
//# sourceMappingURL=index.js.map